// import Navbar from "../component/Navbar/NavBar";
import useStyles from "./styles.js";
import GooglePlay from "../assests/google-play.svg";
import ApplePay from "../assests/app-store.svg";
// import Mobile from "../assests/mobile.svg";
import Cardinal from "../assests/cardinalimg.svg";
import HeroImg from "../assests/heroimg.svg";
// import { Grid } from "@mui/material";

const Hero = ({ AboutRef }) => {
  const classes = useStyles();
  return (
    <div className={classes.heromain}>
      <div className={classes.herocont}>
        <div className={classes.heromargin}>
          {/* <Navbar FooterRef={FooterRef} HowitworksRef={HowitworksRef} AboutRef={AboutRef} /> */}
          <div className={classes.heroorig}>
            <div className={classes.blurbcg}></div>
            <div className={classes.heroitems}>
              <h1>Monetizing Trust Amongst Friends.</h1>
              <div className={classes.seconditem}>
                <h4>
                  A seamless way for you and your trusted friends to save,
                  rotate, and grow funds—with flexibility and accountability
                  built in.
                </h4>
                <h5 className={classes.tandc}>
                  T and C: <strong>Strictly ONLY FOR FRIENDS</strong> - Go get
                  some!
                </h5>
              </div>
            </div>
            <div className={classes.heroContainer}>
              <div className={classes.heroimgMain}>
                <img src={HeroImg} alt="Hero" className={classes.heroimg} />
              </div>
              {/* <div className={classes.heroimgMobile}>
                <img src={Mobile} alt="Mobile" className={classes.heroimg} />
              </div> */}
            </div>
          </div>
          <section ref={AboutRef} className={classes.itembackground}>
            <div className={classes.secondfinancesection}>
              <div className={classes.forcardinal}>
                <img src={Cardinal} alt="cardinal-img" />
              </div>
              <div className={classes.principle}>
                <div className={classes.secondsection}>
                  <h2>SLOT Finance is built on three cardinal principles</h2>
                </div>
                <div>
                  <div className={classes.feature}>
                    <h3>Friends</h3>
                    <p>
                      Your money is always safer with people you trust. That’s
                      why SLOT is strictly invite-only—no strangers, no risks.
                    </p>
                  </div>
                  <div className={classes.feature}>
                    <h3>Flexibility</h3>
                    <p>
                      Life is unpredictable. You can adjust your slot, pause
                      contributions, pay your dues later, or switch payout dates
                      when needed.
                    </p>
                  </div>
                  <div className={classes.feature}>
                    <h3>Fractional</h3>
                    <p>
                      Unlike traditional Ajo, you can contribute anywhere from
                      20% to 400% of a slot or multiple slots—customizing your
                      financial participation like never before.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className={classes.appsection}>
            <h4>With SLOT, you’re in control not the system.</h4>
            <div className={classes.heroimgs}>
              <a 
                href="https://play.google.com/store/apps/details?id=com.slotmobile&pcampaignid=web_share" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Download on Google Play"
              >
                <img src={GooglePlay} alt="Google Play" />
              </a>
              <img src={ApplePay} alt="Apple Pay" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
